import { BellRing } from "lucide-react";
import { useAllAutomations } from "../../../../../hooks/QueryHooks";
import { cn } from "../../../../../lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";
import useWorkspaceStore from "../../../../../store/workspace/workspaceStore";

type Props = {
  status: string;
  setStatus: (status: string) => void;
  alert: string;
  setAlert: (alert: string) => void;
};

const statusOptions = [
  { value: "all", label: "All" },
  { value: "error", label: "Error" },
  { value: "success", label: "Success" },
];

const SignalLogControls = ({
  status,
  setStatus,
  alert,
  setAlert,
}: Props) => {
  const workspace = useWorkspaceStore((state) => state.workspace);

  const allAutomations: any = useAllAutomations({
    workspaceId: workspace?.id,
    automationType: "signal",
    enabled: !!workspace?.id,
  });

  const alertOptions = [
    { value: "all", label: "All Alerts" },
    ...((allAutomations?.data || []).map((automation: any) => ({
      value: automation.id,
      label: automation.name || "Untitled",
    }))),
  ];

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-6 py-4">
      <h2 className="text-base font-semibold text-foreground">Signal Logs</h2>

      <div className="flex flex-wrap items-center gap-2">
        <div className="inline-flex items-center rounded-lg border border-border bg-muted p-0.5">
          {statusOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setStatus(option.value)}
              className={cn(
                "rounded-[5px] px-3 py-1 text-xs font-medium transition-colors",
                status === option.value
                  ? "bg-card text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              {option.label}
            </button>
          ))}
        </div>

        <Select value={alert} onValueChange={setAlert}>
          <SelectTrigger className="h-8 w-[220px] gap-2 text-xs">
            <BellRing className="h-3.5 w-3.5 text-muted-foreground" />
            <SelectValue placeholder="Select alert" />
          </SelectTrigger>
          <SelectContent>
            {alertOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default SignalLogControls;
